<template>
  <div
    t-data="feature-container"
    @mouseover="setPreviewImage(feature.title)"
    @mouseout="setDefaultPreviewImage"
    class="mt-0"
  >
    <h6
      t-data="feature-title"
      class="mb-0 pt-4 card-title pb-4 headerTextColor--text"
    >
      {{ feature.title }}
    </h6>
    <span class="body-regular" t-data="feature-description">{{
      feature.description
    }}</span>
    <banner-error
      v-if="isQuicKLinks(feature.title)"
      :show="isErrorQuickLinks"
      msg="Please select all 4 and not less than 4."
    ></banner-error>
    <v-row class="mb-3 mt-4">
      <v-col
        t-data="content-container"
        class="no-top-bottom-space information-label body-regular"
        cols="12"
      >
        <content-item
          class="mt-2"
          v-for="(content, indexContent) in feature.contents"
          :key="`content-${indexContent}`"
          :name="content.name"
          :status="featureItemStatus(feature.title, content.status)"
          @click="
            e => handleSwitch(e, feature.title, indexFeature, indexContent)
          "
        ></content-item>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {featurePreviewImageName, featureTitleEnum} from '@/constants/feature-setup'
import ContentItem from '@/components/feature-setup/ContentItem'
import BannerError from '@/components/BannerError'
import {mapState} from 'vuex'

export default {
  name: 'FeatureItem',
  props: {
    indexFeature: {type: Number},
    feature: {type: Object},
    isErrorQuickLinks: {type: Boolean}
  },
  components: {
    ContentItem,
    BannerError
  },
  computed: {
    ...mapState('featureSetup', ['featureSetupDetail'])
  },
  methods: {
    setPreviewImage(index) {
      if (Object.keys(featurePreviewImageName).includes(index)) {
        this.$emit('ChangePreview', featurePreviewImageName[index])
      } else {
        this.setDefaultPreviewImage()
      }
    },
    setDefaultPreviewImage() {
      this.$emit('ChangePreview', 'preview-main.png')
    },
    isQuicKLinks(title) {
      return title === featureTitleEnum.QUICK_LINKS
    },
    featureItemStatus(title, status) {
      if (title === featureTitleEnum.MENU_BOTTOM) {
        return undefined
      } else {
        return status
      }
    },
    handleSwitch(status, title, indexFeature, indexContent) {
      if (this.isQuicKLinks(title)) this.$emit('ChangeIsErrorQuickLinks', false)
      this.featureSetupDetail.features[indexFeature].contents[
        indexContent
      ].status = status
    },
  }
}
</script>

<style scoped>
</style>
